import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import '../../styles/Header.css';
import NotificationBell from './NotificationBell';

const Header = ({ onMenuClick, title = 'Dashboard' }) => {
  const { currentUser, logout } = useAuth();
  const { messages } = useData();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const unreadMessages = messages.filter(msg => 
    msg.receiverId === currentUser?.id && !msg.read
  ).length;

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // Add these two new functions
  const handleProfileClick = () => {
    navigate('/profile');
    setShowDropdown(false);
  };

  const handleSettingsClick = () => {
    navigate('/settings');
    setShowDropdown(false);
  };

  const getRoleLabel = (role) => {
    switch (role) {
      case 'owner':
        return 'Owner';
      case 'project_manager':
        return 'Project Manager';
      case 'hr':
        return 'HR Manager';
      case 'employee':
        return 'Employee';
      default:
        return 'User';
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-btn" onClick={onMenuClick}>
          <i className="fas fa-bars"></i>
        </button>
        <h1 className="header-title">{title}</h1>
      </div>

      <div className="header-right">
        <NotificationBell />
        <div className="header-profile">
          <button 
            className="profile-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="profile-avatar">
              {currentUser?.name?.charAt(0) || 'U'}
            </div>
            <div className="profile-info">
              <span className="profile-name">{currentUser?.name || 'User'}</span>
              <span className="profile-role">{getRoleLabel(currentUser?.role)}</span>
            </div>
            <i className="fas fa-chevron-down"></i>
          </button>

          {showDropdown && (
            <div className="profile-dropdown">
              {/* Changed these two items to buttons with onClick handlers */}
              <button className="dropdown-item" onClick={handleProfileClick}>
                <i className="fas fa-user"></i>
                Profile
              </button>
              <button className="dropdown-item" onClick={handleSettingsClick}>
                <i className="fas fa-cog"></i>
                Settings
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-btn" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
